import React from 'react'
import {
	Box, Card, CardHeader, Typography, Table, TableHead, TableBody, TableRow, TableCell,
	Checkbox, IconButton, Toolbar, Grid
} from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'


const DEMO_EXPORTS = [
	{
		fileName: 'grouped_export_spain_20250210_0800.csv',
		created: '10 Feb 2025 08:15',
		exportDate: '10 Feb 2025 08:22',
		exported: true,
		hasUrl: true,
	},
	{
		fileName: 'grouped_export_uk_20250210_0600.csv',
		created: '10 Feb 2025 06:05',
		exportDate: '10 Feb 2025 06:18',
		exported: true,
		hasUrl: true,
	},
	{
		fileName: 'grouped_export_france_20250210_1000.csv',
		created: '10 Feb 2025 10:02',
		exportDate: null,
		exported: false,
		hasUrl: false,
	},
	{
		fileName: 'grouped_export_germany_20250209_1900.csv',
		created: '09 Feb 2025 19:03',
		exportDate: '09 Feb 2025 19:15',
		exported: true,
		hasUrl: true,
	},
	{
		fileName: 'grouped_export_italy_20250209_0900.csv',
		created: '09 Feb 2025 09:00',
		exportDate: null,
		exported: false,
		hasUrl: false,
	},
]


export default function GroupingExportsDemoData() {
	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Card>
				<CardHeader title={
					<Typography variant="subtitle1" fontWeight={600}>Grouped Exports List 09 Feb 2025 - 10 Feb 2025</Typography>
				} />

				<Toolbar variant="dense" sx={{ px: 2, minHeight: 40 }}>
					<Typography variant="caption" color="text.secondary">
						{DEMO_EXPORTS.length} exports
					</Typography>
				</Toolbar>

				<Box sx={{ px: 2, pb: 2, overflowX: 'auto' }}>
					<Table size="small">
						<TableHead>
							<TableRow sx={{ '& th': { bgcolor: 'primary.main', color: 'white', fontWeight: 600, fontSize: '0.75rem', whiteSpace: 'nowrap' } }}>
								<TableCell padding="checkbox"><Checkbox size="small" disabled /></TableCell>
								<TableCell>File Name</TableCell>
								<TableCell align="center">Creation Date</TableCell>
								<TableCell align="center">Export Date</TableCell>
								<TableCell align="center">Exported</TableCell>
								<TableCell align="center">Info</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{DEMO_EXPORTS.map(r => (
								<TableRow key={r.fileName} sx={{ '& td': { py: 1.5, fontSize: '0.8rem' } }}>
									<TableCell padding="checkbox"><Checkbox size="small" disabled /></TableCell>

									<TableCell>
										<Typography variant="body2" fontWeight={500}>{r.fileName}</Typography>
									</TableCell>

									<TableCell align="center">
										<Typography variant="caption">{r.created}</Typography>
									</TableCell>

									<TableCell align="center">
										<Typography variant="caption">{r.exportDate || '—'}</Typography>
									</TableCell>

									<TableCell align="center">
										<IconSeeker
											icon={r.exported ? 'square-check' : 'square-xmark'}
											sx={{ color: `colors.${r.exported ? 'green' : 'red'}`, fontSize: '1.5rem' }}
										/>
									</TableCell>

									<TableCell align="center">
										<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
											<IconButton size="small" title="More info">
												<IconSeeker icon="circle-info" size="xs" />
											</IconButton>
											{r.hasUrl && <IconButton size="small" title="Export URL">
												<IconSeeker icon="down-to-bracket" size="xs" />
											</IconButton>}
										</Box>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</Box>
			</Card>
		</Grid>
	</Grid>
}
